import { FC } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import ImageWithEmptyFallback from "src/components/ImageWithEmptyFallback/ImageWithEmptyFallback";
import Config from "src/app.config";
import { useTopupDetails } from "../../context/TopupDetailsContext";
import { SummaryRow } from "./TopupSummary";

export type RechargeValues = {
  serviceValue: string;
  serviceFeesDisplay: string;
  totalAmount: string;
  points: string;
  currency: string;
};

type Props = RechargeValues & {
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const RechargeConfirmation: FC<Props> = ({
  serviceValue,
  serviceFeesDisplay,
  totalAmount,
  points,
  currency,
  isLoading,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  const { item } = useTopupDetails();

  return (
    <div className="flex flex-col justify-between gap-4 p-4">
      <div className="flex flex-col gap-8">
        <div className="border-border-default flex items-center gap-3 border-b pb-4">
          <div className="outline-border-default aspect-square rounded-md bg-background-default w-20 flex items-center justify-center p-1 outline">
            <ImageWithEmptyFallback className="aspect-square max-w-25 rounded-sm" src={`${Config.GCP_IMAGES_BUCKET}${item?.imageUrl}`} />
          </div>
          <div className="flex flex-col items-start">
            <div className="text-sm font-semibold">{item?.brand}</div>
            <div className="text-font-subtle text-xs">{item?.name}</div>
          </div>
        </div>
        <div className="border-border-default flex flex-col gap-2 border-b pb-4">
          <SummaryRow label={t("Topup.serviceValue")} value={`${serviceValue} ${currency}`} />
          <SummaryRow label={t("Topup.serviceFees")} value={serviceFeesDisplay} />
        </div>
        <div className="flex flex-col gap-2">
          <SummaryRow label={t("Topup.totalAmount")} value={`${totalAmount} ${currency}`} bold />
          <SummaryRow label={t("Topup.pointsRequired")} value={`${points} ${t("Topup.pointsSuffix")}`} bold />
        </div>
      </div>

      <Button type="primary" size="large" block loading={isLoading} iconPlacement="end" className="bg-background-primary! font-semibold!" onClick={onConfirm}>
        {t("Topup.confirmRecharge")}
      </Button>
      <Button type="text" block disabled={isLoading} onClick={onCancel}>
        {t("Topup.goBack")}
      </Button>
    </div>
  );
};

export default RechargeConfirmation;
